'use client';
import { useEffect } from 'react';
import { tinykeys } from 'tinykeys';

export const useKeyDown = (key: string | number, fn: () => void, deps: unknown[] = []) => {
  useEffect(() => {
    const unsub = tinykeys(window, {
      [`${key}`](event) {
        event.preventDefault();
        fn();
      },
    });

    return () => {
      unsub();
    };
  }, deps);
};
